import React from 'react';
import './Details.scss';

const Details = ({ items }) => {
  return (
    <div className="details">
      <div className="details__items">
        {items.map((item, x) => {
          const shouldRender =
            item !== undefined &&
            item !== null &&
            item !== false &&
            item !== '';

          return (
            shouldRender && (
              <div key={x} className="details__item">
                {item}
              </div>
            )
          );
        })}
      </div>
    </div>
  );
};

export default Details;
